import { PARSIVE_ENABLED, PARSIVE_API_KEY, PARSIVE_WIDGET_ID } from "../settings/config";

// Let TypeScript know about the global the widget exposes.
declare global {
    interface Window {
        Parsive?: (command: "start" | "stop", options?: { apiKey?: string; widgetId?: string }) => void;
    }
}

// Turn the widget ON. Returns a function that turns it OFF again.
export const startParsiveWidget = (): (() => void) => {
    if (!PARSIVE_ENABLED || !PARSIVE_API_KEY || !PARSIVE_WIDGET_ID) {
        return () => {};
    }

    window.Parsive?.("start", { apiKey: PARSIVE_API_KEY, widgetId: PARSIVE_WIDGET_ID });

    return () => window.Parsive?.("stop");
};
